export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label="Andersen mark"
    >
      <rect width="32" height="32" rx="6" fill="var(--c-fjord)" />
      <path
        d="M8 22 L16 9 L24 22 M11.4 16.4 L20.6 16.4"
        stroke="var(--c-amber)"
        strokeWidth="2.4"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
